import {
    faArrowRightFromArc,
    faArrowRightToArc,
    faBan,
    faLoader,
    faQuestion,
    faWrench,
} from '@fortawesome/pro-regular-svg-icons';

import { eventMessages } from 'src/features/events/utils/messages';
import { type BadgeOptions } from 'src/types/ui';
import { generalMessages } from 'src/utils/messages';

const badgeStatusFilterOptions: BadgeOptions = {
    entry_events: {
        theme: 'green',
        label: eventMessages.entry,
    },
    exit_events: {
        theme: 'fuchsia',
        label: eventMessages.exit,
    },
    extra_events: {
        theme: 'gray',
        label: eventMessages.extraEvents,
    },
};

const badgeStatusOptions: BadgeOptions = {
    'exit-failed': {
        theme: 'red',
        icon: faBan,
        label: eventMessages.exitFailed,
    },
    exit: {
        theme: 'gray',
        icon: faLoader,
        label: eventMessages.exitAttempt,
    },
    'exit-success': {
        theme: 'fuchsia',
        icon: faArrowRightFromArc,
        label: eventMessages.exitSuccess,
    },
    service: {
        theme: 'primary',
        icon: faWrench,
        label: generalMessages.service,
    },
    entry: {
        theme: 'gray',
        icon: faLoader,
        label: eventMessages.entryAttempt,
    },
    'entry-success': {
        theme: 'emerald',
        icon: faArrowRightToArc,
        label: eventMessages.entrySuccess,
    },
    'entry-failed': {
        theme: 'amber',
        icon: faBan,
        label: eventMessages.entryFailed,
    },
    unknown: {
        theme: 'gray',
        icon: faQuestion,
        label: generalMessages.unknown,
    },
};

const cardTypeOptions = {
    PREPAID: eventMessages.cardTypePrepaid,
    OPERATOR: eventMessages.cardTypeOperator,
    NORMAL: eventMessages.cardTypeNormal,
    VIP: eventMessages.cardTypeVIP,
};

export { badgeStatusFilterOptions, badgeStatusOptions, cardTypeOptions };
